import { jsx } from 'react/jsx-runtime';
import React__default, { useMemo } from 'react';

/**
 * Se tra i children c'è un componente text, lo wrappo con uno span.
 * Spesso è utile perchè il testo semplice non è cosiderato un elmento e il CSS non applica alcune regole di selezione.
 * @param {object} children nodo/nodi React.
 * @returns {object} nodo/nodi React.
 */
function useChildrenWithText(children) {
    return useMemo(() => React__default.Children.map(children, (child) => {
        if (typeof child === 'string') {
            if (child.trim().length === 0)
                return undefined;
            return jsx("span", { children: child });
        }
        return child;
    }), [children]);
}

export { useChildrenWithText as default };
